<template>
  <modal :show.sync="visible" @update:show="handleModalClose" class="dark-modal logout-confirmation-modal">
    <div class="modal-box">
      <div class="modal-box-header">
        <h2 class="modal-title">{{ $t('logout.confirmTitle') }}</h2>
      </div>
      
      <div class="modal-body">
        <p class="confirmation-message">{{ $t('logout.confirmMessage') }}</p>
      </div>

      <div class="modal-footer">
        <button 
          type="button" 
          class="button cancel-button"
          @click="cancelLogout"
        >
          {{ $t('logout.cancelButton') }}
        </button>
        <button 
          type="button" 
          class="button is-danger"
          @click="confirmLogout"
        >
          {{ $t('logout.confirmButton') }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import { Modal } from '@cyradar/ui'

/**
 * LogoutConfirmation Component
 * 
 * Displays a confirmation dialog before logout to prevent accidental logout.
 * Integrates with the existing UI framework and maintains dark theme consistency.
 */
export default {
  name: 'LogoutConfirmation',
  components: {
    Modal
  },
  props: {
    /**
     * Controls the visibility of the confirmation dialog
     */
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false
    }
  },
  watch: {
    /**
     * Sync the internal visible state with the prop
     */
    show: {
      immediate: true,
      handler(newValue) {
        this.visible = newValue
      }
    }
  },
  methods: {
    /**
     * Handles the confirmation of logout action
     */
    confirmLogout() {
      this.visible = false
      this.$emit('confirm')
    },

    /**
     * Handles the cancellation of logout action
     */
    cancelLogout() {
      this.visible = false
      this.$emit('cancel')
    },

    /**
     * Handles modal close events (ESC key, click outside)
     */
    handleModalClose(value) {
      if (!value) {
        this.$emit('cancel')
      }
    }
  }
}
</script>

<style lang="scss">
.logout-confirmation-modal {
  .modal-content {
    max-width: 500px;
  }

  .modal-body {
    padding: 1rem 0;
    min-height: 80px;

    .confirmation-message {
      color: rgba(255, 255, 255, 0.9);
      font-size: 1rem;
      line-height: 1.5;
      margin: 0;
    }
  }

  .modal-box-header .modal-title {
    font-size: 1.25rem;
  }

  .modal-footer {
    margin-top: 1.5rem;
  }
}
</style>
